[0,3,7,13,20,26,33,39,49,66,82,98,115,131,148,164,197,230,262,295,328,410,492,656,820,984]
